import { NewLeadFormData } from '@/controllers/Lead';

import { initialState } from './constants';
import { AllActivities, LeadsReducerState } from './types';

function setModalOpen(state: LeadsReducerState, open: boolean): void {
  state.leadDuplicationModal.isOpened = open;
}

function setLeadDuplicateInfo(state: LeadsReducerState, records: AllActivities): void {
  const modal = state.leadDuplicationModal;

  modal.isOpened = records.totalCount > 0;
  modal.totalAmount = records.totalCount;
  modal.duplicationsList = records.itemList;
}

function setFormData(state: LeadsReducerState, formData: NewLeadFormData): void {
  state.leadDuplicationModal.newLeadData = { formData };
}

function setLeadCreationError(state: LeadsReducerState, msg: string): void {
  state.errorMessage = msg;
}

function resetCreationModal(state: LeadsReducerState): void {
  state.errorMessage = null;
  state.leadDuplicationModal = initialState.leadDuplicationModal;
}

function setAssignmentInProgress(state: LeadsReducerState, inProgress: boolean): void {
  state.assignmentInProgress = inProgress;
}

function setQualifyLeadInProgress(state: LeadsReducerState, inProgress: boolean): void {
  state.qualifyLeadInProgress = inProgress;
}

function setQualifyingLeadError(state: LeadsReducerState, error: string): void {
  state.qualifyingLeadError = error;
}

function setDisqualifyLeadInProgress(state: LeadsReducerState, inProgress: boolean): void {
  state.disqualifyLeadInProgress = inProgress;
}

function setDisqualifyLeadError(state: LeadsReducerState, error: string): void {
  state.disqualifyingLeadError = error;
}

export const leadsReducer = {
  setModalOpen,
  setFormData,
  setLeadDuplicateInfo,
  setLeadCreationError,
  resetCreationModal,
  setAssignmentInProgress,
  setQualifyLeadInProgress,
  setQualifyingLeadError,
  setDisqualifyLeadInProgress,
  setDisqualifyLeadError,
} as const;
